<template>
  <b-row>
    <b-col cols="12" md="4" offset-md="4">
      <b-card v-if="requestAllowed && !requestHandled">
        <b-card-title>Email Suffix Request</b-card-title>
        <p>Email suffix: <strong>{{ suffix }}</strong></p>
        <p class="card-text">Would you like to request this suffix to be added to your company's approved list of suffixes?
          The request will be sent to your company administrators.</p>
        <p><b-button variant="success" @click.prevent="submitSuffixRequest(true)">Request Suffix</b-button></p>
        <p><b-button variant="danger" @click.prevent="submitSuffixRequest(false)">Decline To Request</b-button></p>
      </b-card>
      <b-card v-else-if="requestHandled">
        <b-card-title>Email Suffix Request</b-card-title>
        <p class="card-text">{{ message }}</p>
      </b-card>
      <b-card v-else>
        <b-card-title>Email Suffix Request</b-card-title>
        <p class="card-text">This link is no longer valid.</p>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BButton,
} from 'bootstrap-vue'

export default {
  name: 'RequestSuffix',
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BButton,
  },
  data() {
    return {
      token: undefined,
      requestAllowed: false,
      suffix: '',
      error: false,
      message: '',
      requestHandled: false,
    }
  },
  created() {
    if (!this.$route.query.token) {
      this.$router.replace({ name: 'error-404' })
    } else {
      this.token = this.$route.query.token
      this.validateToken()
    }
  },
  methods: {
    validateToken() {
      this.$http.get('public.cfc?method=validateSuffixRequestToken', {
        params: {
          token: this.token,
        },
      })
        .then(response => {
          if (response.data.status) {
            this.suffix = response.data.suffix
            this.requestAllowed = true
          } else {
            this.requestAllowed = false
          }
        })
    },
    submitSuffixRequest(option) {
      this.$http.get('public.cfc?method=actionSuffixRequest', {
        params: {
          token: this.token,
          suffix: this.suffix,
          action: option,
        },
      })
        .then(response => {
          if (response.data.status) {
            this.message = response.data.message
            this.requestHandled = true
          } else {
            this.error = true
          }
        })
        .catch(() => {
          this.error = true
        })
    },
  },
}

</script>
